<div class="d-flex align-items-center gap-1">
  <p-buttongroup>
    <p-button
      size="small"
      [severity]="debugEnabled ? 'warn' : 'primary'"
      [label]="preference.selectedViewLabel"
      icon="ri-external-link-line"
      (onClick)="openPreview()"
    ></p-button>
    <p-button
      size="small"
      [severity]="debugEnabled ? 'warn' : 'primary'"
      icon="ri-arrow-down-s-line"
      ariaLabel="Vorschau-Optionen"
      i18n-ariaLabel="@@preview-options-aria"
      (onClick)="viewPopover.toggle($event)"
    ></p-button>
  </p-buttongroup>

  <p-popover
    #viewPopover
    appendTo="body"
  >
    <div class="preview-options">
      <div class="d-flex align-items-center justify-content-between gap-2 preview-debug-toggle">
        <span i18n="@@preview-debug-label">Debugging</span>
        <div class="d-flex align-items-center gap-2">
          <p-selectbutton
            size="small"
            [options]="debugOptions"
            [unselectable]="true"
            optionLabel="label"
            optionValue="value"
            [ngModel]="debugEnabled"
            (ngModelChange)="setDebugEnabled($event)"
          ></p-selectbutton>
          <p-selectbutton
            size="small"
            [options]="placementOptions"
            [unselectable]="true"
            [disabled]="!debugEnabled"
            optionLabel="label"
            optionValue="value"
            [ngModel]="preference.debugPlacement"
            (ngModelChange)="setDebugPlacement($event)"
          >
            <ng-template
              pTemplate="item"
              let-option
            >
              <i
                class="preview-placement-icon"
                [class]="option.icon"
                [pTooltip]="option.label"
                tooltipPosition="bottom"
                tooltipStyleClass="preview-placement-tooltip"
                appendTo="body"
              ></i>
            </ng-template>
          </p-selectbutton>
        </div>
      </div>

      @for (item of viewItems; track item.url) {
      <button
        type="button"
        class="preview-option-button"
        [class.preview-active-item]="isSelected(item.url)"
        (click)="openPreview(item.url, item.label); viewPopover.hide()"
      >
        <i [class]="item.icon"></i>
        <span>{{ item.label }}</span>
      </button>
      }
    </div>
  </p-popover>
</div>